import { IServerTime } from './server-time.interface';
import { ILocalStorageDriver } from '../../../common/local-storage-driver.interface';
import { DataStorageDriver } from '../../../common/data-storage-driver';
import { ICachedTime } from './cached-time.interface';
import config from 'config';

export class ServerTime implements IServerTime {
	cachedTime: ICachedTime = {
		time: null,
		offset: null,
	};
	storage: ILocalStorageDriver = new DataStorageDriver();
	storageKey: string = 'SessionService/CachedTime';
	private async syncDate(): Promise<void> {
		try {
			const apiEndpoint = config.tokenServiceBaseUrl;
			const serverTimeEndpoint = `${apiEndpoint}/server-time`;

			const response = await fetch(serverTimeEndpoint);
			const date = (await response.json()) as { serverTime: number };
			await this.storeTimeInCache({
				time: date.serverTime,
				offset: date.serverTime - this.getCurrentTime(),
			});
		} catch (e) {
			await this.storeTimeInCache({
				time: this.getCurrentTime(),
				offset: 0,
			});

			console.error('Failed to fetch server time: ', e);
		}

		this.cachedTime = JSON.parse(await this.storage.get(this.storageKey));
	}

	public async now(): Promise<number> {
		const cachedTime = await this.storage.get(this.storageKey);

		if (!cachedTime) {
			await this.syncDate();
		} else {
			this.cachedTime = JSON.parse(cachedTime);
		}

		return this.getCurrentTime() + this.cachedTime.offset;
	}

	private async storeTimeInCache(time: ICachedTime): Promise<void> {
		const monthInSeconds = 2592000;

		await this.storage.set(this.storageKey, JSON.stringify(time), monthInSeconds);
	}

	private getCurrentTime(): number {
		// Current time in milliseconds
		return new Date().getTime();
	}
}
